/* eslint-disable react/no-unescaped-entities */
import React from 'react';



const TermsOrganizerCookiesScreen: React.FC = () => {
  return (

    <body style={{
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      height: '100%',
      backgroundColor: 'white',
      color: 'black',
    }}>

      <h1>ORGANIZER</h1>

      <h2>POLITICA DE COOKIES</h2>

    </body>

  );
};



export default TermsOrganizerCookiesScreen;
